@file:OptIn(InternalResourceApi::class)

package animations.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/animations.core.ui.generated.resources/"

@delegate:ResourceContentHash(359_851_952)
internal val Res.drawable.avd: DrawableResource by lazy {
      DrawableResource("drawable:avd", setOf(
        ResourceItem(setOf(), "${MD}drawable/avd.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_142_353_649)
internal val Res.drawable.cat: DrawableResource by lazy {
      DrawableResource("drawable:cat", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_124_744_128)
internal val Res.drawable.code: DrawableResource by lazy {
      DrawableResource("drawable:code", setOf(
        ResourceItem(setOf(), "${MD}drawable/code.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-930_455_583)
internal val Res.drawable.faders: DrawableResource by lazy {
      DrawableResource("drawable:faders", setOf(
        ResourceItem(setOf(), "${MD}drawable/faders.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_519_424_216)
internal val Res.drawable.fan: DrawableResource by lazy {
      DrawableResource("drawable:fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(153_498_559)
internal val Res.drawable.ic_blogger: DrawableResource by lazy {
      DrawableResource("drawable:ic_blogger", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_blogger.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(57_791_341)
internal val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-246_575_402)
internal val Res.drawable.ic_linkedin: DrawableResource by lazy {
      DrawableResource("drawable:ic_linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_linkedin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_247_236_356)
internal val Res.drawable.ic_mastodon: DrawableResource by lazy {
      DrawableResource("drawable:ic_mastodon", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mastodon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(466_733_000)
internal val Res.drawable.ic_medium: DrawableResource by lazy {
      DrawableResource("drawable:ic_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(910_747_501)
internal val Res.drawable.ic_twitter: DrawableResource by lazy {
      DrawableResource("drawable:ic_twitter", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_twitter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(987_926_321)
internal val Res.drawable.link: DrawableResource by lazy {
      DrawableResource("drawable:link", setOf(
        ResourceItem(setOf(), "${MD}drawable/link.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_033_525_124)
internal val Res.drawable.minus: DrawableResource by lazy {
      DrawableResource("drawable:minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_639_426_674)
internal val Res.drawable.vd_heart: DrawableResource by lazy {
      DrawableResource("drawable:vd_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/vd_heart.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("avd", Res.drawable.avd)
  map.put("cat", Res.drawable.cat)
  map.put("code", Res.drawable.code)
  map.put("faders", Res.drawable.faders)
  map.put("fan", Res.drawable.fan)
  map.put("ic_blogger", Res.drawable.ic_blogger)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_linkedin", Res.drawable.ic_linkedin)
  map.put("ic_mastodon", Res.drawable.ic_mastodon)
  map.put("ic_medium", Res.drawable.ic_medium)
  map.put("ic_twitter", Res.drawable.ic_twitter)
  map.put("link", Res.drawable.link)
  map.put("minus", Res.drawable.minus)
  map.put("vd_heart", Res.drawable.vd_heart)
}
